import React from 'react'
import DOMPurify from 'dompurify'

export default function StringToHtml ({ value }: { value: string }) {
  return <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(value || '') }} />
}
